import { logger } from '../../../../../../../util/logger';
import { SystemUnit } from '../../../../../shared/model/flow.types';
import { convertUnits } from '../../../../../shared/util/math';

export enum SystemUnitOfMeasure {
  INCH = 'in',
  CENTIMETER = 'cm',
  METER = 'm',
}

const convertStitchInputValueToUom = (
  value: number,
  system: SystemUnit
): number => {
  return convertUnits(value, getUom(system), SystemUnitOfMeasure.METER, {
    precision: 6,
  });
};

const convertStitchSystemValueToUom = (
  value: number,
  system: SystemUnit,
  precision = 6
): number => {
  return convertUnits(value, SystemUnitOfMeasure.METER, getUom(system), {
    precision,
  });
};

const getUom = (system: SystemUnit): SystemUnitOfMeasure => {
  return system === SystemUnit.IMPERIAL
    ? SystemUnitOfMeasure.INCH
    : SystemUnitOfMeasure.CENTIMETER;
};

const getReadableValue = (
  value: number,
  system: SystemUnit
): string | undefined => {
  const uom = getUom(system);

  if (uom === SystemUnitOfMeasure.INCH) {
    return value === 1 ? '1 inch' : `${value} inches`;
  } else if (uom === SystemUnitOfMeasure.CENTIMETER) {
    return value === 1 ? '1 centimeter' : `${value} centimeters`;
  } else {
    logger.error('Could not get readable unit of measure', { uom });
  }
};

export {
  convertStitchInputValueToUom,
  convertStitchSystemValueToUom,
  getReadableValue,
  getUom,
};
